import React from 'react';
import { FiActivity, FiPlusCircle, FiCalendar, FiBook } from 'react-icons/fi';
import './NutritionQuickTools.css';

const NutritionQuickTools = ({ onMacroCalculator, onCreatePlan, onBuildMealPlan, onAddRecipe }) => {
  const tools = [
    {
      id: 'macro-calculator',
      label: 'Macro Calculator',
      icon: FiActivity,
      description: 'Calculate client macros',
      color: '#ff6b35',
      onClick: onMacroCalculator
    },
    {
      id: 'create-plan',
      label: 'Create Plan',
      icon: FiPlusCircle,
      description: 'New nutrition plan',
      color: '#f4a261',
      onClick: onCreatePlan
    },
    {
      id: 'meal-plan',
      label: 'Build Meal Plan',
      icon: FiCalendar,
      description: 'Plan weekly meals',
      color: '#2a9d8f',
      onClick: onBuildMealPlan
    },
    {
      id: 'add-recipe',
      label: 'Add Recipe',
      icon: FiBook,
      description: 'Create new recipe',
      color: '#e76f51',
      onClick: onAddRecipe
    }
  ];

  return (
    <div className="nutrition-quick-tools">
      <div className="tools-header">
        <h3>Quick Tools</h3>
        <p>Fast access to nutrition features</p>
      </div>

      <div className="tools-grid">
        {tools.map((tool) => {
          const IconComponent = tool.icon;
          return (
            <button
              key={tool.id}
              className="tool-card"
              onClick={tool.onClick}
              style={{ '--tool-color': tool.color }}
            >
              <div className="tool-icon">
                <IconComponent />
              </div>
              <div className="tool-content">
                <h4>{tool.label}</h4>
                <p>{tool.description}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NutritionQuickTools;
